import { useAdminDatacenters } from '../../hooks/useAdminDatacenters';

export function AdminDatacentersTab() {
  const { dcs, loading, error } = useAdminDatacenters();

  return (
    <div>
      {error && (
        <div style={{
          background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
          borderRadius: 6, padding: '10px 14px', color: '#f87171', fontSize: 13, marginBottom: 16,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        }}>
          <span>{error}</span>
        </div>
      )}
      <div style={{
        background: '#111827', border: '1px solid #1f2937', borderRadius: 8, overflow: 'hidden',
      }}>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid #1f2937' }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#e5e7eb' }}>
            Дата-центры
            <span style={{ marginLeft: 8, fontSize: 11, color: '#6b7280', fontWeight: 400 }}>({dcs.length})</span>
          </span>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#0f172a' }}>
              {['Код', 'Название', 'Ряды × Стойки', 'Стратегия маршрутизации', 'Действия'].map(h => (
                <th key={h} style={{
                  padding: '9px 12px', textAlign: 'left',
                  fontSize: 10, fontWeight: 700, color: '#6b7280',
                  textTransform: 'uppercase', letterSpacing: '0.07em',
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: '24px', textAlign: 'center', color: '#4b5563' }}>Загрузка...</td></tr>
            ) : dcs.map(dc => (
              <tr key={dc.code} style={{ borderBottom: '1px solid #1f2937' }}>
                <td style={{ padding: '10px 12px', fontFamily: 'monospace', color: '#60a5fa', fontWeight: 600 }}>{dc.code}</td>
                <td style={{ padding: '10px 12px', color: '#e5e7eb', fontWeight: 500 }}>{dc.name}</td>
                <td style={{ padding: '10px 12px', color: '#9ca3af' }}>{dc.rows_count} × {dc.max_racks_per_row}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{
                    fontSize: 11, padding: '2px 7px', borderRadius: 4,
                    background: 'rgba(59,130,246,0.1)', color: '#60a5fa',
                    border: '1px solid rgba(59,130,246,0.2)',
                  }}>{dc.routing_strategy}</span>
                </td>
                <td style={{ padding: '10px 12px', display: 'flex', gap: 6 }}>
                  <a href={`/${dc.code}/floor-plan`}
                    style={{
                      padding: '3px 8px', fontSize: 11,
                      background: 'rgba(59,130,246,0.1)',
                      border: '1px solid rgba(59,130,246,0.3)',
                      borderRadius: 4, color: '#60a5fa',
                      textDecoration: 'none',
                    }}>
                    План зала
                  </a>
                  <a href={`/${dc.code}/calculator`}
                    style={{
                      padding: '3px 8px', fontSize: 11,
                      background: 'rgba(16,185,129,0.08)',
                      border: '1px solid rgba(16,185,129,0.3)',
                      borderRadius: 4, color: '#34d399',
                      textDecoration: 'none',
                    }}>
                    Калькулятор
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
